<div>
    <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
          <button type="button" pButton icon="fa fa-plus" (click)="add()"
                  label="{{ 'BTN_AGREGAR' | translate}}"></button>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                 (input)="dt.filterGlobal($event.target.value, 'contains')">
        </div>
    </div>
    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
            <p-table 
                    [columns]="columnas" 
                    [value]="listValidityDocuments" 
                    [paginator]="true" 
                    [rows]="10"
                    [responsive]="true" 
                    paginatorPosition="bottom" 
                    [loading]="carTabla"
                    #dt>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                            class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                        </th>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row let-index="rowIndex">
                    <tr [pSelectableRow]="row">
                        <td>{{row.codigo}}</td>
                        <td>{{row.nombre}}</td>
                        <td>{{row.descripcion}}</td>
                        <td>{{row.tipoVigencia}}</td>
                        <td>{{row.duracionVigencia ? row.duracionVigencia : '--'}}</td>
                        <td class="text-center">
                            <div class="btn-group" role="group">
                              <button type="button" class="p-button p-button-info btn btnDown" icon="fa fa-arrow-down" data-toggle="tooltip"
                                      title="{{'BTN_ABAJO' | translate}}" *ngIf="index >=0 && index<listValidityDocuments.length-1"
                                      pButton (click)="cambiarOrden(row, false)"></button>
                              <button type="button" class="p-button p-button-info btn btnUp" icon="fa fa-arrow-up" data-toggle="tooltip"
                                      title="{{'BTN_ARRIBA' | translate}}" pButton *ngIf="index >0"
                                      (click)="cambiarOrden(row, true)"
                              ></button>
                            </div>
                          </td>
                        <td class="text-center"><p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox></td>
                        <td class="text-center"><p-checkbox [(ngModel)]="row.indicadorTercero" binary="true" disabled="true"></p-checkbox></td>
                        <td class="text-center"><p-checkbox [(ngModel)]="row.indicadorSolicitarCliente" binary="true" disabled="true"></p-checkbox></td>
                        <td class="text-center">
                        <div class="btn-group" role="group">
                            <button type="button" icon="fa fa-eye" class="ui-button-success" data-toggle="tooltip" title="{{'BTN_VISUALIZAR' | translate}}"
                                pButton (click)="detail(row)"></button>
                            <button type="button" icon="fa fa-pencil" class="ui-button-success" data-toggle="tooltip" title="{{'BTN_EDITAR' | translate}}"
                                pButton (click)="edit(row)"></button>
                        </div>
                        </td>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length" class="text-center">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                        </td>
                    </tr>
                    </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-confirmDialog width="400" #cd>
	<p-footer>
		<button type="button" pButton icon="fa fa-close" label="{{ 'BTN_NO' | translate }}" (click)="cd.reject()"></button>
		<button type="button" pButton icon="fa fa-check" label="{{ 'BTN_SI' | translate }}" (click)="cd.accept()"></button>
	</p-footer>
</p-confirmDialog>